import { render, staticRenderFns } from "./GatGridFooter.vue?vue&type=template&id=595c8964&scoped=true&"
import script from "./GatGridFooter.vue?vue&type=script&lang=js&"
export * from "./GatGridFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595c8964",
  null
  
)

export default component.exports